import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Shared {
  navbarFunction!: () => void;

  registerNavbarFunction(fn: () => void) {
    this.navbarFunction = fn;
  }

  callNavbarFunction() {
    if (this.navbarFunction) {
      this.navbarFunction();
    }
  }

  private requestSignupSubject = new Subject<void>();
  requestSignup$ = this.requestSignupSubject.asObservable();

  requestSignUp() {
    this.requestSignupSubject.next();
  }

  private closeDropdownSubject = new Subject<void>();
  closeDropdown$ = this.closeDropdownSubject.asObservable();

  requestCloseDropdown() {
    this.closeDropdownSubject.next();
  }

  private renewCreditsSubject = new Subject<void>();
  renewCredits$ = this.renewCreditsSubject.asObservable();

  requestRenewCredits() {
    this.renewCreditsSubject.next();
  }

  constructor() { }
}
